import { atom, selector } from 'recoil';
import { SubClient, SubClientConfiguration } from '../types/subClient';

export const subClientsSearchFilterState = atom<string | undefined>({
  key: 'app.subClients.search.filter',
  default: undefined,
});

export const subClientAssetsSearchFilterState = atom<string | undefined>({
  key: 'app.subClients.assets.search.filter',
  default: undefined,
});

export const subClientState = atom<SubClient | undefined>({
  key: 'app.subClient',
  default: undefined,
});

export const editSubClientConfigurationState = atom<SubClientConfiguration | undefined>({
  key: 'app.subClient.configuration.edit',
  default: selector({
    key: 'app.subClient.configuration.edit.default',
    get: ({ get }) => {
      const subClient = get(subClientState);
      return subClient?.configuration;
    },
  }),
});
